import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { QuestionnaireService } from "../services/questionnaire.service";
import { LeadService } from "../services/lead.service";
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { HelpDialogComponent } from "../help-dialog/help-dialog.component";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { RestartDialogComponent } from "../restart-dialog/restart-dialog.component";
import { filter } from 'rxjs/operator/filter';
import { Step } from '../models/step.model';

@Component({
	selector: 'app-mashkanta-questioner',
	templateUrl: './mashkanta-questioner.component.html',
	styleUrls: ['./mashkanta-questioner.component.scss']
})
export class MashkantaQuestionerComponent implements OnInit {
	modalRef;
	showScrollHint = false;
	selectImageUrl: string = '';
	steps: Step[] = [];
	currentStep: Step;
	constructor(
		private questionnaireService: QuestionnaireService,
		private leadService: LeadService,
		private router: Router,
		private modalService: NgbModal,
		private changeDetectorRef: ChangeDetectorRef
	) { }




	ngOnInit() {
		this.steps = this.questionnaireService.getSteps().filter(l => l.stepId.toString() !== '7');
		this.currentStep = this.getStepFromUrl(this.router.url);
		this.getImageUrlFromStep(this.currentStep.stepId.toString());
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				let eventNavigationEnd = event as NavigationEnd;
				// let strArr:string[] = eventNavigationEnd.url.split('/');
				//  let currentStepName= strArr[2];
				//  if(this.currentStep.stepName!==currentStepName){
				//  let step :Step = this.steps.find(l=>l.stepName==currentStepName);
				//  if(step){
				// 	this.selectImageUrl='step_'+step.stepId.toString()+'.jpg';
				//  }
				// }
				let step: Step = this.getStepFromUrl(eventNavigationEnd.url);
				if (step) {
					if (this.currentStep.stepName !== step.stepName) {
						if (step != null) {
							this.selectImageUrl = this.getImageUrlFromStep(step.stepId.toString());
							this.currentStep = step;
						} else {

						}
					}
				}

			}
		});
		this.questionnaireService.scrollHintVisibleChange.subscribe(show => {
			this.showScrollHint = show;
			//console.log("1)************************************",this.showScrollHint);
			if (!this.changeDetectorRef['destroyed']) {
				this.changeDetectorRef.detectChanges();
			}

		}
		);

		//this.showScrollHint=true;
	}
	getImageUrlFromStep(stepId: string): string {
		if (stepId !== '0' && stepId != '7')
			return this.selectImageUrl = 'step_' + stepId.toString() + '.png';
		else
			return '';
	}
	getStepFromUrl(url: string): Step | null {
		let strArr: string[] = url.split('/');
		if (strArr.length > 2) {
			let currentStepName = strArr[2];
			let step: Step = this.steps.find(l => l.stepName == currentStepName);
			if (step) {
				return step;
			} else {
				return null;
			}
		} else {
			return null;
		}


	}

	test1() {
		console.log(">>>>   ", this.showScrollHint);
	}

	openHelpDialog() {
		this.modalRef = this.modalService.open(HelpDialogComponent);
		// .result.then((result) => {
		//   this.closeResult = `Closed with: ${result}`;
		// }, (reason) => {
		//   this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
		// });
	}

	// restartClick() {
	// 	console.log(">>> restartClick()");
	// 	this.modalRef = this.modalService.open(RestartDialogComponent).result.then((result) => {
	// 				this.questionnaireService.reset("1");
	// 		this.router.navigate([""]).then(
	// 		res=>{
	// 			this.router.navigate(["questionnaire", "user-details", "1"]);
	// 		}
	// 	);
	//   });



	//}
	// sendFormTest() { //TODO: remove
	// 	this.leadService.submitMashForm().subscribe(
	// 		data => {
	// 			console.log("send lead sucseed");
	// 		});
	// }
}



// WEBPACK FOOTER //
// ./src/app/mashkanta-questioner/mashkanta-questioner.component.ts